<template>
  <div class="mx-auto" :style="styleMainContainer">
    <AnimatePresence>
      <MotionDiv
        v-if="runIndependent && selectedEventItem"
        :key="'event-item-modal-root'"
        :initial="{ opacity: 0 }"
        :animate="{ opacity: 1 }"
        :exit="{ opacity: 0 }"
        :transition="{ duration: 0.3 }"
        class="fixed z-50 inset-0"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
        style="z-index: 1000;"
      >
        <div
          class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"
        >
          <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
          <div
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
            aria-hidden="true"
            @click="setSelectedEventItem(null)"
          ></div>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:h-screen" aria-hidden="true"
            >&#8203;</span
          >

          <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->

          <motion.div
            :key="activeModalLayoutId"
            :layoutId="activeModalLayoutId"
            layout
            :initial="{ opacity: 0, scale: 0.95 }"
            :animate="{ opacity: 1, scale: 1 }"
            :transition="{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }"
            class="relative inline-flex w-screen bg-white rounded-lg px-0 text-left shadow-xl sm:my-8 sm:max-w-md md:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl sm:w-full"
            style="max-height: calc(100vh - 100px)"
          >
            <div class="flex flex-col" v-if="selectedEventItem">
              <div
                class="absolute top-0 right-0 bg-white rounded-md -mr-1 -mt-1 shadow-lg text-lg border w-8 h-8 flex justify-center items-center cursor-pointer hover:scale-105 transform transition duration-300"
                @click="unsetSelectedEventItem()"
              >
                <i class="fa-solid fa-xmark"></i>
              </div>

              <div class="fixed flex items-center justify-center space-x-2 bottom-0 w-screen right-0 z-50 pb-3 lg:hidden">
                <div
                class=" bg-white rounded-md  shadow-lg text-lg border w-8 h-8 inline-flex justify-center items-center cursor-pointer hover:scale-105 transform transition duration-300"
                v-if="prevEventItemProperty"
                @click="setSelectedEventItem(prevEventItemProperty)"
              >
                <i class="fas fa-chevron-left"></i>
              </div>
                <div
                class=" bg-white rounded-md  shadow-lg text-lg border w-8 h-8 inline-flex justify-center items-center cursor-pointer hover:scale-105 transform transition duration-300"
                v-if="nextEventItemProperty"
                @click="setSelectedEventItem(nextEventItemProperty)"
              >
                <i class="fas fa-chevron-right"></i>
              </div>
              
                </div>

              <div
                class=" hidden absolute top-0 right-0 bg-white rounded-md -mr-4 mt-20 shadow-lg text-lg border w-8 h-8 lg:flex justify-center items-center cursor-pointer hover:scale-105 transform transition duration-300"
                v-if="nextEventItemProperty"
                @click="setSelectedEventItem(nextEventItemProperty)"
              >
                <i class="fas fa-chevron-right"></i>
              </div>
              <div
                class="hidden absolute top-0 left-0 bg-white rounded-md -ml-4 mt-20 shadow-lg text-lg border w-8 h-8 lg:flex justify-center items-center cursor-pointer hover:scale-105 transform transition duration-300"
                v-if="prevEventItemProperty"
                @click="setSelectedEventItem(prevEventItemProperty)"
              >
                <i class="fas fa-chevron-left"></i>
              </div>
              <div
                class="flex items-center text-xxs px-3 md:px-4 space-x-2 mt-2"
              >
                <div
                  class="flex items-center justify-center px-1.5 py-0.5 rounded-md"
                  :class="
                    'text-custom-' +
                    getSessionColorId(selectedEventItem.event_session_id) +
                    '-800 bg-custom-' +
                    getSessionColorId(selectedEventItem.event_session_id) +
                    '-50 '
                  "
                >
                  <!-- Heroicon name: outline/check -->
                  <i
                    class="fal"
                    :class="selectedEventItem.event_item_type.key_icon.icon"
                    v-if="selectedEventItem.event_item_type.key_icon"
                  ></i>
                  <span class="font-medium ml-2"
                    >{{
                      selectedEventItem.event_item_type
                        ? translateField(selectedEventItem.event_item_type.name)
                        : ""
                    }}
                    <span class="inline-block ml-1 font-light"
                      >#{{ selectedEventItem.computedNumber }}</span
                    ></span
                  >
                </div>

                <div
                  class="px-1 py-0.5 text-xxs inline-block rounded-md ml-1 font-light border border-gray-100 text-gray-400"
                  v-if="
                    (true == true && selectedEventItem.is_presented_online) ||
                    (eventData &&
                      eventData.display_schedule_item_online_status &&
                      eventItem.is_presented_online)
                  "
                >
                  <span v-if="selectedEventItem.is_presented_online"
                    ><i class="fa-light fa-globe mr-1"></i>
                    {{ translate("conference.participation_online") }}</span
                  >
                </div>
              </div>
              <h3
                class="text-base md:text-lg leading-tight font-medium text-gray-900 pt-0 px-3 md:px-4"
                id="modal-title"
              >
                {{ translateField(selectedEventItem.name) }}
              </h3>

              <div class="flex px-3 md:px-4">
                <div
                  v-if="selectedEventItem.event_item_type.lecture"
                  class="text-sm inline-block rounded-md px-1 py-0 font-bold"
                >
                  <i class="fal fa-clock mr-1 fa-fw"></i>
                  {{ getFormattedTime(selectedEventItem) }} -
                  {{ getFormattedTime(selectedEventItem.end_time) }}
                  <span class="font-normal ml-2">
                    <i class="fal fa-calendar mr-1 fa-fw"></i>
                    {{
                      getDateObject(selectedEventItem.start_time).format("L")
                    }}
                    ({{
                      getDateObject(selectedEventItem.start_time).format(
                        "dddd"
                      )
                    }})</span
                  >
                </div>
              </div>
              <div
                      class="mt-0 flex items-center text-sm px-4 md:px-5 py-0.5" v-if="selectedEventItem"
                      
                    >
                      <!-- Heroicon name: outline/check -->
                      <i class="fal fa-map-marker fa-fw"></i>
                      <span
                        class="font-normal ml-2"
                        v-if="selectedEventItem.eventRoomId"
                        >{{
                          translateField(
                            program.rooms[selectedEventItem.eventRoomId].name
                          )
                        }}</span
                      >
                    </div>

              <div class="flex flex-col overflow-y-scroll px-3 md:px-4 pb-3 md:pb-4">
                <div
                  class="my-2 text-bold text-base text-red-600"
                  v-if="selectedEventItem.is_canceled"
                >
                  <div
                    class="rounded-md px-1.5 py-1 font-bold text-red-600 bg-red-100 inline-block"
                  >
                    <i class="fa-solid fa-ban"></i>
                    {{ translate("conference.item_cancelled") }}
                  </div>
                </div>
                <div
                  class="mb-2 shadow px-2 py-1 bg-white rounded-md right-0 border-b-2 relative text-xs ml-0.5 transform hover:scale-102 duration-300 flex cursor-pointer justify-between"
                  @click.stop="
                    setSelectedEventSession(selectedEventItem.event_session_id)
                  "
                  :class="
                    'bg-text-' +
                    getSessionColorId(selectedEventItem.event_session_id) +
                    '-700 border-custom-' +
                    getSessionColorId(selectedEventItem.event_session_id) +
                    '-100'
                  "
                >
                  <div
                    class="text-gray-400"
                    :class="
                      ' text-custom-' +
                      getSessionColorId(selectedEventItem.event_session_id) +
                      '-800'
                    "
                  >
                    <small>
                      {{
                        translateField(
                          getSession(selectedEventItem.event_session_id)
                            .event_session_type.name
                        )
                      }}</small
                    >
                    <div class="font-medium">
                      {{
                        translateField(
                          getSession(selectedEventItem.event_session_id)
                            .shortRecordName
                        )
                      }}
                    </div>
                  </div>
                  <div class="flex items-center justify-center">
                    <i class="fal fa-chevron-right"></i>
                    </div>
                </div>
                <div class="mt-1 text-left sm:mt-1">
              

                  <div
                    class="mt-0.5 mb-0.5 text-sm leading-snug text-gray-500 order-2 font-normal"
                  >
                    {{
                      getAuthorText(selectedEventItem)
                        ? getAuthorText(selectedEventItem)["author"]
                        : ""
                    }}
                  </div>
                  <div
                    class="text-xs leading-snug text-gray-500 order-3 font-normal"
                  >
                    {{
                      getAuthorText(selectedEventItem)
                        ? getAuthorText(selectedEventItem)["company"]
                        : ""
                    }}
                  </div>
                  <div class="mt-3 text-left sm:mt-2">
                    <div
                      class="text-sm text-gray-500 eventschedule overflow-y-auto"
                      v-html="translateField(selectedEventItem.description)"
                    ></div>
                  </div>
                </div>
                <!-- This closes div.mt-3.text-left.sm:mt-2 -->
              </div>
              <!-- This is the new closing tag for the div that started at line ~75 -->
            </div>
            <!-- This closes the inner motion.div -->
          </motion.div>
          <!-- This closes the outer motion.div (modal panel) -->
        </div>
      </MotionDiv>
    </AnimatePresence>
    <AnimatePresence>
    <MotionDiv
      v-if=" selectedEventSession"
    
      :initial="{ opacity: 0 }"
      :animate="{ opacity: 1 }"
      :exit="{ opacity: 0 }"
      :transition="{ duration: 0.1 }"
      class="fixed z-50 inset-0"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
      style="z-index: 1000;"
    >
      <div
      class="flex items-end justify-center pt-4 px-4 pb-20 text-center sm:block sm:p-0"      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          aria-hidden="true"
          @click="unsetAll()"
        ></div>

        

        <motion.div
        
          :initial="{ opacity: 0, scale: 0.95 }"
          :animate="{ opacity: 1, scale: 1 }"
          :exit="{ opacity: 0, scale: 0.95 }"
          :transition="{ duration: 0.3, ease: [0.4, 0, 0.2, 1] }"
          class="relative inline-flex w-screen flex-col  bg-white rounded-lg px-0 text-left shadow-xl sm:my-8 sm:max-w-md md:max-w-2xl xl:max-w-3xl 2xl:max-w-4xl sm:w-full"
          style="max-height: calc(100vh - 100px)"
        >
        <div class="flex flex-col" >
          <div
            class="absolute top-0 right-0 bg-white rounded-md -mr-1 -mt-1 shadow-lg text-lg border w-8 h-8 flex justify-center items-center cursor-pointer hover:scale-105 transform transition duration-300 z-10"
            @click="setSelectedEventSession(null)"
          >
            <i class="fa-solid fa-xmark"></i>
          </div>
          <div class="px-3 md:px-4 mt-3 md:mt-4">
            <div
                  class="inline-flex items-center justify-center px-1.5 py-0.5 rounded-md font-medium text-xxs"
                  :class="
                    'text-custom-' +
                    getSessionColorId(selectedEventSession.id) +
                    '-800 bg-custom-' +
                    getSessionColorId(selectedEventSession.id) +
                    '-50'
                  "
                >
                  <span class="font-medium">{{
                    selectedEventSession.event_session_type
                      ? translateField(
                          selectedEventSession.event_session_type.name
                        )
                      : ""
                  }}</span>
                </div>
            <h3
                class="text-lg md:text-xl leading-tight font-medium text-gray-900 mb-2"
                id="modal-title"
              >
                {{ translateField(selectedEventSession.shortRecordName) }}
              </h3>
            <div
                  class="inline-flex items-center text-base rounded-md  font-medium"
                 
                >
                  <i class="fal fa-calendar mr-1.5"></i>
                  <span>
                    {{ getFormattedTime(selectedEventSession) }}
                    <span
                      v-if="
                        getDateObject(selectedEventSession.start_time).format(
                          'L'
                        ) !=
                        getDateObject(selectedEventSession.end_time).format('L')
                      "
                    >
                      <span class="font-normal ml-1">
                       
                        {{
                          getDateObject(selectedEventSession.start_time).format(
                            "L"
                          )
                        }}
                        ({{
                          getDateObject(selectedEventSession.start_time).format(
                            "dddd"
                          )
                        }})
                      </span>
                    </span>
                    -
                    {{ getFormattedTime(selectedEventSession.end_time) }}
                    <span class="font-normal ml-1">
                      {{
                        getDateObject(selectedEventSession.end_time).format("L")
                      }}
                      ({{
                        getDateObject(selectedEventSession.end_time).format(
                          "dddd"
                        )
                      }})
                    </span>
                  </span>
                </div>

             
              </div>
        
          </div>

       
         

          <div class="flex-grow overflow-y-auto">
            <div class="px-4 pt-5 pb-4 sm:p-4">
           

              <div
                v-if="
                  selectedEventSession &&
                  selectedEventSession.event_session_chairs &&
                  selectedEventSession.event_session_chairs.length > 0
                "
                class="mb-3 mt-2"
              >
                <transition-group name="list" tag="ul" class="">
                  <li
                    v-for="sessionGroup in selectedEventSession.event_session_chairs"
                    :key="sessionGroup[0].key_role.id"
                    class="mb-1.5"
                  >
                    <b class="text-sm mb-0.5 font-medium block">{{
                      sessionGroup[0].key_role.translated_name
                    }}</b>
                    <ul class="pl-2"> <!-- CORRECTED COMMENT HERE -->
                      <li
                        v-for="contactLeader in sessionGroup"
                        :key="contactLeader.id"
                        class="text-sm font-normal"
                      >
                        {{ contactLeader.contact.full_name_with_title }}
                      </li>
                    </ul>
                  </li>
                </transition-group>
              </div>

              <div
                v-if="parentEventSession"
                class="inline-block mb-3"
                @click="setSelectedEventSession(parentEventSession.id)"
              >
                <div
                  class="border leading-none rounded-md px-2 py-1.5 transform hover:scale-103 transition duration-250 ease-in-out cursor-pointer"
                  :class="
                    'border-custom-' +
                    getSessionColorId(parentEventSession.id) +
                    '-200 ' +
                    'hover:border-custom-' +
                    getSessionColorId(parentEventSession.id) +
                    '-400 ' +
                    'bg-custom-' +
                    getSessionColorId(parentEventSession.id) +
                    '-50'
                  "
                >
                  <div class="text-xxs text-gray-500 mb-0.5 font-light">
                    <i class="fal fa-chevron-down mr-1"></i>
                    {{ translate("conference.belongs_to") }}
                  </div>

                  <div class="flex items-center text-xs">
                    <div
                      class="flex items-center justify-center py-0 rounded-md"
                      :class="
                        'text-custom-' +
                        getSessionColorId(parentEventSession.id) +
                        '-900 '
                      "
                    >
                      <span class="font-medium">{{
                        parentEventSession.event_session_type
                          ? translateField(
                              parentEventSession.event_session_type.name
                            )
                          : ""
                      }}</span>
                    </div>
                  </div>
                  <h3
                    class="text-sm leading-snug font-bold"
                    :class="'text-custom-' + getSessionColorId(parentEventSession.id) + '-900'"
                  >
                    {{ translateField(parentEventSession.shortRecordName) }}
                  </h3>
                </div>
              </div>

              <div class="overflow-x-auto">
                <table class="divide-y divide-gray-300 w-full min-w-64">
                
                  <tbody class="divide-y divide-gray-200 bg-white">
                    <template v-for="dateGroup in groupedSessionEventItemsByDate" :key="dateGroup.date">
                      <tr>
                        <td colspan="2" class="bg-gray-50 text-gray-700 font-semibold text-sm text-center py-1">
                         <i class="fal fa-calendar mr-1"></i> {{ dateGroup.formattedDate }}
                        </td>
                      </tr>
                      <tr
                        class="hover:bg-gray-50 transition duration-150 ease-in-out cursor-pointer"
                        @click="setSelectedEventItem(eventItem)"
                        v-for="eventItem in dateGroup.items"
                        :key="eventItem.id"
                      >
                        <td class="py-4 pl-4 pr-3 text-sm sm:pl-6">
                          <div class="flex leading-tight items-start">
                            <i
                              class="fal fa-clock fa-fw mr-2 text-base text-gray-400 mt-0.5" 
                            ></i>
                            <div class="text-xs">
                             
                              
                              <div class="font-bold mt-0.5 text-gray-800">
                                {{ getFormattedTime(eventItem) }}
                              </div>
                            </div>
                          </div>
                          <div class="flex leading-tight mt-1.5 items-start">
                            <i
                              class="fal fa-map-marker-alt fa-fw mr-2 text-base text-gray-400 mt-0.5"
                            ></i>
                            <div class="text-xs">
                              <span
                                class="font-medium text-gray-700 leading-none"
                                v-if="eventItem.eventRoomId"
                              >
                                {{
                                  translateField(
                                    program.rooms[eventItem.eventRoomId].name
                                  )
                                }}
                              </span>
                               <span v-else class="text-gray-400 italic text-xxs">No room specified</span>
                            </div>
                          </div>
                        </td>

                        <td class="px-3 py-4 text-sm text-gray-500">
                          <div
                            class="z-10 bg-white right-0 text-xs rounded-md relative px-1 py-0.5 ml-0.5 mb-1 transform hover:scale-102 duration-300 inline-block cursor-pointer"
                            @click.stop="
                              setSelectedEventSession(eventItem.event_session_id)
                            "
                            :class="
                              'bg-custom-' +
                              getSessionColorId(eventItem.event_session_id) +
                              '-50 border border-custom-' +
                              getSessionColorId(eventItem.event_session_id) +
                              '-100'
                            "
                          >
                            <div
                              class="text-xxs"
                              :class="
                                'text-custom-' +
                                getSessionColorId(eventItem.event_session_id) +
                                '-700'
                              "
                            >
                              {{
                                translateField(
                                  getSession(eventItem.event_session_id)
                                    .shortRecordName
                                )
                              }}
                            </div>
                          </div>
                          <div class="flex mt-0.5 leading-tight mb-1">
                            <div class="block">
                              <div
                                class="bg-gray-100 text-gray-600 inline-block text-xxs px-1 py-0.5 rounded font-medium"
                              >
                                {{
                                  eventItem.event_item_type
                                    ? translateField(
                                        eventItem.event_item_type.name
                                      )
                                    : ""
                                }}
                                (#{{ eventItem.computedNumber }})
                              </div>
                            </div>
                          </div>

                          <h3
                            class="text-sm leading-snug font-semibold text-gray-800 mb-0.5"
                          >
                            {{ translateField(eventItem.name) }}
                          </h3>

                          <div
                            v-if="getAuthorText(eventItem) && getAuthorText(eventItem)['author']"
                            class="mt-0.5 mb-0.5 text-xs leading-snug text-gray-600 order-2 font-medium"
                          >
                            {{ getAuthorText(eventItem)["author"] }}
                          </div>
                          <div
                            v-if="getAuthorText(eventItem) && getAuthorText(eventItem)['company']"
                            class="text-xxs leading-snug text-gray-500 order-3 font-normal"
                          >
                            {{ getAuthorText(eventItem)["company"] }}
                          </div>
                        </td>
                      </tr>
                    </template>
                    <tr v-if="!groupedSessionEventItemsByDate || groupedSessionEventItemsByDate.length === 0">
                      <td colspan="2" class="text-center py-10 text-gray-500 italic">
                        No presentations listed for this session.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </MotionDiv>
  </AnimatePresence>

    <div class="flex h-full flex-col relative" style="height: calc(100vh)">
      <a
        v-if="!maxSchedule"
        @click="maxSchedule = true"
        class="cursor-pointer absolute flex justify-center inset-0 w-full h-full bg-white hover:bg-opacity-80 bg-opacity-40 z-50 duration-200 transition transform ease-in-out hover:scale-105" style="z-index: 60;"
      >
        <div class="">
          <span
            class="text-2xl bg-primary-500 text-white cursor-pointer font-bold rounded-md shadow inline-block px-3 py-2 mt-10 duration-200 transition transform ease-in-out hover:scale-105"
          >
            <i class="fal fa-maximize"></i>
            {{ translate("conference.open_schedule") }}
          </span>
        </div>
      </a>
      <div
        ref="schedule_area"
        class="flex flex-auto flex-col overflow-auto bg-white relative schedule-widget-area"
        :style="{ zoom: autoScroll ? '0.8' : '1' }"
      >
        <div
          class="flex flex-wrap sticky left-0 w-full top-0 bg-white z-50 justify-center relative"
          ref="dateMenu"
        >
          <div class="absolute top-0 left-0">
            <div
              v-if="maxSchedule"
              @click="maxSchedule = false"
              class="rounded-md px-1 py-0.5 mt-1 ml-1.5 text-base inline-block font-light shadow-md border cursor-pointer transition transform ease-in-out hover:scale-105 duration-200 bg-white hover:bg-gray-100"
            >
              <i class="far fa-close fa-fw"></i>
            </div>
          </div>
          <ul
            class="flex p-2 overflow-x-auto ml-6 md:ml-0"
            v-if="program && program.dates && dateMenu"
          >
            <li class="mr-2" v-for="(dateItem, index) in dateMenu" :key="index">
              <a
                :class="{
                  'bg-gray-500': selectedDate == index,
                  'text-white': selectedDate == index,
                  'hover:bg-gray-100': selectedDate != index,
                  'text-gray-600': selectedDate != index,
                  'border-gray-300': selectedDate != index,
                }"
                @click="selectedDate = index"
                class="cursor-pointer transition-all duration-150 inline-block border-b leading-tight text-center border-white rounded-md py-1 px-2.5 h-full"
              >
                <div
                  class="flex justify-center items-center flex-col my-auto h-full"
                >
                  <div class="font-semibold text-sm relative">
                    <div
                      class="w-full absolute top-0 -mt-4"
                      v-if="index == 123"
                    >
                      <span
                        class="text-3xs uppercase bg-white font-light border border-primary-300 rounded-md px-1 text-primary-700"
                        >{{ translate("conference.today") }}</span
                      >
                    </div>
                    <span v-if="index != 'poster'">
                      {{ getDateObject(index).format("L") }}
                    </span>
                    <span v-if="index == 'poster'"> Poster </span>
                  </div>

                  <div class="font-light text-xs" v-if="index != 'poster'">
                    {{ getDateObject(index).format("dddd") }}
                  </div>
                </div>
              </a>
            </li>
          </ul>
          <div class="my-auto" v-if="!autoScroll">
            <search-bar
              :domain="domain"
              :event-id="entity"
              v-on:open-event-item="setSelectedEventItem"
            ></search-bar>
          </div>
          <div class="my-auto ml-1" v-if="!autoScroll">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <div class="relative inline-block text-left">
              <div>
                <button
                  @click="showRoomMenu = !showRoomMenu"
                  type="button"
                  ref="roomMenuButton"
                  :class="{
                    'text-red-600':
                      roomsForDate.length != eventRoomsMenu.length,
                    'text-gray-700':
                      roomsForDate.length == eventRoomsMenu.length,
                  }"
                  class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-1 bg-white text-sm font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary-500"
                  id="menu-button"
                  aria-expanded="true"
                  aria-haspopup="true"
                >
                  <i class="fal mr-1.5 fa-location-dot my-auto"></i>
                  {{ roomsForDate.length }}/{{ eventRoomsMenu.length }}
                  <!-- Heroicon name: solid/chevron-down -->
                  <svg
                    class="-mr-1 ml-2 h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    />
                  </svg>
                </button>
              </div>

              <transition
                enter-active-class="transition ease-out duration-100"
                enter-from-class="transform opacity-0 scale-95"
                enter-to-class="transform opacity-100 scale-100"
                leave-active-class="transition ease-in duration-75"
                leave-from-class="transform opacity-100 scale-100"
                leave-to-class="transform opacity-0 scale-95"
              >
                <div
                  ref="roommenu"
                  :style="{ height: menuHeight }"
                  v-if="showRoomMenu"
                  class="origin-top-right overflow-y-scroll absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none transition transform ease-in-out duration-200"
                  role="menu"
                  aria-orientation="vertical"
                  aria-labelledby="menu-button"
                  tabindex="-1"
                  v-closable="{
                    exclude: ['roomMenuButton'],
                    handler: 'closeRoomDropdown',
                  }"
                >
                  <div ref="roomDropdown">
                    <transition-group
                      name="list"
                      tag="div"
                      class="py-1"
                      role="none"
                    >
                      <!-- Active: "bg-gray-100 text-gray-900", Not Active: "text-gray-700" -->
                      <a
                        key="allRooms"
                        v-if="eventRoomsDeselected.length > 0"
                        @click="eventRoomsDeselected = []"
                        class="cursor-pointer hover:bg-gray-100 text-gray-700 block px-4 py-2 text-sm relative border-b border-gray-200"
                        role="menuitem"
                        tabindex="-1"
                        ><i class="far fa-list-check mr-1"></i>
                        {{ translate("conference.show_all_rooms") }}</a
                      >

                      <a
                        v-for="room in eventRoomsMenu"
                        :key="room.id"
                        @click="addOrRemoveRoom(room.id)"
                        class="cursor-pointer hover:bg-gray-100 text-gray-700 block px-4 py-2 pr-3 text-sm relative border-b border-gray-200"
                        :class="{
                          'opacity-50': eventRoomsDeselected.includes(room.id),
                        }"
                        role="menuitem"
                        tabindex="-1"
                        id="menu-item-0"
                      >
                        <span
                          class="inline-flex h-full items-center justify-center mr-1"
                        >
                          <div
                            class="text-gray-400 bg-white rounded-md border border-gray-100 px-0.5 hover:text-gray-500 transition duration-200 cursor-pointer"
                            title="Hide other rooms"
                          >
                            <i
                              v-if="!eventRoomsDeselected.includes(room.id)"
                              class="text-green-600 group-hover:text-green-700 fal fa-fw fa-check-circle"
                              aria-hidden="true"
                            />
                            <i
                              v-if="eventRoomsDeselected.includes(room.id)"
                              class="text-gray-300 fal fa-fw fa-check-circle"
                              aria-hidden="true"
                            />
                          </div>
                        </span>
                        {{ room.name }}
                        <span
                          class="flex h-full items-center justify-center absolute right-0 top-0"
                          @click.stop="onlyRoom(room.id)"
                        >
                          <div
                            class="text-gray-400 bg-white mr-1 rounded-md border border-gray-100 px-0.5 hover:text-gray-500 transition duration-200 cursor-pointer"
                            title="Hide other rooms"
                          >
                            <i class="fal fa-fw fa-crosshairs"></i>
                          </div>
                        </span>
                        <div class="flex gap-2">
                          <div
                            v-for="(sessionId, sessionIndex) in sessionsOfDay[
                              room.id
                            ]"
                            :key="
                              'session-' +
                              room.id +
                              '-' +
                              sessionId +
                              '-' +
                              sessionIndex
                            "
                            :title="
                              translateField(program.sessions[sessionId].name)
                            "
                            :class="
                              'text-custom-' +
                              getSessionColorId(sessionId) +
                              '-700 bg-custom-' +
                              getSessionColorId(sessionId) +
                              '-100 rounded-md text-xxs font-bold px-1 leading-3 flex truncate opacity-75'
                            "
                          >
                            <p
                              class="font-normal text-ellipsis overflow-hidden max-w-6 truncate"
                            >
                              <span
                                class="font-bold"
                                v-if="program.sessions[sessionId].extension"
                                >{{
                                  program.sessions[sessionId].extension
                                }}: </span
                              >{{
                                translateField(program.sessions[sessionId].name)
                              }}
                            </p>
                          </div>
                        </div>
                      </a>
                    </transition-group>
                  </div>
                </div>
              </transition>
            </div>
          </div>
          <div
            class="my-auto ml-2 flex shadow-md rounded-md overflow-hidden divide-x divide-gray-300 bg-white border border-gray-300"
            v-if="program && program.print_link && !autoScroll"
          >
            <div class="inline-flex justify-center items-center mx-3">
              <i class="fal fa-print text-gray-400 text-sm"></i>
            </div>

            <a
              :title="translate('conference.print_by_time')"
              :alt="translate('conference.print_as_table')"
              class="inline-flex justify-center w-full px-2 py-1.5 bg-gray-50 text-base font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary-700 text-gray-700"
              :href="program.print_link_table"
              target="_blank"
            >
              <i class="fal fa-table text-gray-600"></i>
            </a>
            <a
              :title="translate('conference.print_by_time')"
              :alt="translate('conference.print_by_time')"
              class="inline-flex justify-center w-full px-2 py-1.5 bg-gray-50 text-base font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary-700 text-gray-700"
              :href="program.print_link"
              target="_blank"
            >
              <i class="fal fa-clock text-gray-600"></i>
            </a>
            <a
              :title="translate('conference.print_by_session')"
              :alt="translate('conference.print_by_session')"
              class="inline-flex justify-center w-full px-2 py-1.5 bg-gray-50 text-base font-medium hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary-700 text-gray-700"
              :href="program.print_link_session"
              target="_blank"
            >
              <i class="fal fa-list-timeline text-gray-600"></i>
            </a>
          </div>

          <div
            class="my-auto ml-2 flex"
            v-if="program && program.print_link && !autoScroll"
          >
            <a
              :title="translate('conference.event_platform')"
              :alt="translate('conference.event_platform')"
              class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-1 bg-white text-sm bg-primary-500 text-white font-medium hover:bg-primary-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-primary-700 duration-200"
              :href="program.event.platform_link"
              v-if="program && program.event && program.event.platform_link"
              target="_blank"
            >
              <i class="fal fa-users mr-1 my-auto"></i>
              {{ translate("conference.event_platform") }}
            </a>
          </div>
          <div
            v-if="!scrollerMaxR"
            @mousedown="moveSchedule(380)"
            @mouseup="scrollerActive = false"
            class="mr-3 lg:mr-6 absolute mt-24 right-0 top-0 rounded-full hover:scale-105 hover:bg-primary-200 transform transition duration-200 bg-primary-100 shadow text-xl cursor-pointer w-8 h-8 flex justify-center items-center"
          >
            <i class="fal fa-chevron-right"></i>
          </div>
          <div
            v-if="!scrollerMaxL"
            @mousedown="moveSchedule(-380)"
            @mouseup="scrollerActive = false"
            class="ml-3 lg:ml-6 absolute mt-24 left-0 top-0 rounded-full bg-primary-100 hover:bg-primary-200 shadow hover:scale-105 transform transition duration-200 text-xl cursor-pointer w-8 h-8 flex justify-center items-center"
          >
            <i class="fal fa-chevron-left"></i>
          </div>
        </div>

        <div style="" class="flex flex-none flex-col max-w-none">
          <div
            class="sticky z-40 flex-none bg-white sm:pr-8 relative"
            ref="roomMenu"
            :style="styleRoomMenu()"
            :class="addTopMenuClass ? 'top-0' : 'top-0'"
          >
            <!--

 :class="'grid-cols-' + roomsForDate.length"
              -->
            <div
              class="-mr-px divide-x divide-gray-200 border-r border-gray-100 text-sm leading-snug bg-gray-50 text-gray-500 grid"
              :style="{
                'grid-template-columns':
                  'repeat(' + roomsForDate.length + ',minmax(10rem,5fr))',
              }"
            >
              <div class="col-end-1 w-20 border-b"></div>
              <div
                class="flex items-center flex-col justify-center py-1 bg-gray-50 border-b text-gray-800"
                v-for="room in roomsForDate"
                :key="room.id"
              >
                <div class="text-center">
                  <span class="font-medium text-xs">{{
                    translateField(program.rooms[room.event_room_id].name)
                  }}</span>
                  <div class="text-center leading-none">
                    <div
                      @click="setSelectedEventSession(sessionId)"
                      v-for="(sessionId, sessionIndex) in sessionsOfDay[
                        room.event_room_id
                      ]"
                      :key="
                        'day-session-' +
                        room.event_room_id +
                        '-' +
                        sessionId +
                        '-' +
                        sessionIndex
                      "
                      :title="translateField(program.sessions[sessionId].name)"
                      :class="
                        'text-custom-' +
                        getSessionColorId(sessionId) +
                        '-700 bg-custom-' +
                        getSessionColorId(sessionId) +
                        '-100 rounded-md text-xxs font-bold px-1 leading-3  opacity-75 inline-block cursor-pointer hover:scale-105 transform transition duration-200'
                      "
                    >
                      <span class="font-normal"
                        ><span
                          class="font-bold"
                          v-if="program.sessions[sessionId].extension"
                          >{{ program.sessions[sessionId].extension }}: </span
                        >{{
                          translateField(program.sessions[sessionId].name)
                        }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="" v-if="selectedDate && selectedDate == 'poster'">
            <!-- This example requires Tailwind CSS v2.0+ -->
            <div class="px-4 sm:px-6 lg:px-8 container mx-auto">
              <div class="mt-8 flex flex-col">
                <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                  <div
                    class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8"
                  >
                    <div
                      class="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg"
                    >
                      <table class="min-w-full divide-y divide-gray-300">
                        <thead class="bg-gray-50">
                          <tr>
                            <th
                              colspan="3"
                              scope="col"
                              class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 w-20"
                            >
                              <div class="flex items-center">
                                <label
                                  for="location"
                                  class="block text-sm font-medium text-gray-700 pr-2"
                                  ><i class="fal fa-filter text-sm"></i
                                ></label>
                                <select
                                  id="location"
                                  v-model="selectedPosterSession"
                                  name="location"
                                  class="mt-1 text-sm block pl-3 pr-10 py-0.5 text-base border-gray-300 focus:outline-none focus:ring-primary-500 focus:border-primary-500 sm:text-sm rounded-md"
                                >
                                  <option :value="null">
                                    {{ translate("conference.all_posters") }}
                                  </option>
                                  <option disabled>-----------------</option>
                                  <option
                                    v-for="paperpool in posterSessions"
                                    :key="paperpool.id"
                                    :value="paperpool.id"
                                    v-text="paperpool.paperpool_name"
                                  ></option>
                                </select>
                              </div>
                            </th>
                          </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200 bg-white">
                          <tr
                            :ref="'schedule-item-' + poster.id"
                            class="hover:scale-102 transition transform duration-300 ease-in-out cursor-pointer"
                            @click="setSelectedEventItem(poster,true)"
                            v-for="poster in posters"
                            :key="poster.id"
                          >
                            <td class="py-4 pl-4 pr-3 text-sm sm:pl-6">
                              <div class="flex items-center">
                                <div class="h-20 w-14 flex-shrink-0 relative">
                                  <div
                                    class="absolute w-full text-center top-0 -mt-3"
                                  >
                                    <div
                                      class="bg-white inline-block text-xxs rounded-md px-1 shadow-md"
                                    >
                                      #{{ poster.computedNumber }}
                                    </div>
                                  </div>
                                  <img
                                    class="item-contain rounded-md shadow-lg"
                                    :src="getPosterImage(poster).sm"
                                    alt=""
                                  />
                                </div>
                              </div>
                            </td>
                            <td
                              class="px-3 py-4 text-sm text-gray-500 cursor-pointer"
                            >
                              <div
                                class="z-10 bg-white right-0 rounded-md relative px-1 shadow-sm overflow-hidden ml-0.5 transform hover:scale-102 duration-300 inline-block"
                                :class="
                                  'bg-text-' +
                                  getSessionColorId(
                                    poster.paperpool_event_session_id
                                  ) +
                                  '-800 bg-custom-' +
                                  getSessionColorId(
                                    poster.paperpool_event_session_id
                                  ) +
                                  '-50'
                                "
                              >
                                <div
                                  class="text-gray-400"
                                  style="font-size: 0.67rem"
                                  :class="
                                    ' text-custom-' +
                                    getSessionColorId(
                                      poster.paperpool_event_session_id
                                    ) +
                                    '-600'
                                  "
                                >
                                  {{
                                    translateField(
                                      getSession(
                                        poster.paperpool_event_session_id
                                      ).shortRecordName
                                    )
                                  }}
                                </div>
                              </div>

                              <h3
                                class="text-sm leading-5 font-medium text-gray-900"
                                id="modal-title"
                              >
                                {{ translateField(poster.name) }}
                              </h3>

                              <div
                                class="mt-0.5 mb-0.5 text-xs leading-snug text-gray-500 truncate order-2 font-medium"
                              >
                                {{
                                  getAuthorText(poster)
                                    ? getAuthorText(poster)["author"]
                                    : ""
                                }}
                              </div>
                              <div
                                class="text-xxs leading-snug text-gray-500 truncate order-3 font-normal"
                              >
                                {{
                                  getAuthorText(poster)
                                    ? getAuthorText(poster)["company"]
                                    : ""
                                }}
                              </div>
                            </td>
                          </tr>

                          <!-- More people... -->
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex flex-auto"
            v-if="selectedDate && selectedDate != 'poster'"
          >
            <div class="sticky left-0 z-20 w-20 flex-none"></div>
            <div class="grid flex-auto relative">
              <div
                ref="timeIndicator"
                v-if="timeIndicatorPosition && timeIndicatorPosition.pixel"
                class="absolute z-30 mt-5 -ml-20 w-20 pr-2 text-right text-xxs leading-4 rounded-full py-0.5 shadow font-bold border-green-200 duration-700"
                :style="{ top: timeIndicatorPosition.pixel + 'rem' }"
              >
                <div
                  class="absolute text-3xs border w-20 text-right border-green-300 whitespace-nowrap px-1 rounded-md bg-green-100 font-extrabold text-green-700"
                >
                  <i class="fal fa-clock"></i> {{ currentTime.format("LT") }}
                </div>
              </div>
              <!-- Horizontal lines -->
              <div
                class="col-start-1 col-end-2 row-start-1 grid divide-y divide-gray-100"
                :style="{
                  'grid-template-rows':
                    'repeat(' +
                    timeRangeLength.length +
                    ', minmax(.7rem, .7rem))',
                }"
              >
                <div class="row-end-1 h-7"></div>

                <div
                  v-for="timeItem in timeRangeLength"
                  :key="timeItem.hour + '_' + timeItem.minute"
                  :style="{
                    'border-color':
                      timeItem.minute % 5 == 0 ? false : 'rgba(0,0,0,0)',
                  }"
                >
                  <div
                    v-if="timeItem.minute % timeLabel == 0"
                    class="sticky left-0 z-20 -mt-2.5 -ml-20 w-20 pr-2 text-right text-xxs leading-4 text-gray-500 rounded-md bg-white py-0.5 shadow font-bold"
                  >
                    {{ timeItem.format }}
                  </div>
                </div>
              </div>

              <!-- Vertical lines -->
              <div
                class="col-start-1 col-end-2 row-start-1 hidden grid-rows-1 divide-x divide-gray-100 grid"
                :class="
                  'grid-cols-' +
                  roomsForDate.length +
                  ' grid-cols-' +
                  roomsForDate.length
                "
                :style="{
                  'grid-template-columns':
                    'repeat(' + roomsForDate.length + ',minmax(10rem,5fr))',
                }"
              >
                <div
                  :class="classItem"
                  v-for="classItem in roomColClasses"
                  :key="classItem"
                ></div>
              </div>
              <!--

                :class="' grid-cols-' + roomsForDate.length"
                -->
              <!-- Events -->
              <ol
                v-if="
                  selectedDate &&
                  program.eventItems &&
                  program.eventItems[selectedDate]
                "
                class="col-start-1 col-end-2 row-start-1 grid grid-cols-1 sm:pr-8 mt-7"
                :style="{
                  'grid-template-rows':
                    'repeat(' +
                    timeRangeLength.length +
                    ', minmax(.7rem, .7rem)) auto',
                  'grid-template-columns':
                    'repeat(' + roomsForDate.length + ',minmax(10rem,5fr))',
                }"
              >
                <template
                  v-for="(room, roomIndex) in roomsForDate"
                  :key="room.event_room_id + '-roomgroup'"
                >
                  <template
                    v-for="eventItem in program.eventItems[selectedDate]?.[
                      room.event_room_id
                    ]?.filter((item) => !item.gap) || []"
                    :key="eventItem.id + '-itemgroup'"
                  >
                    <!-- Static Display LI -->
                    <li
                      :ref="'schedule-item-' + eventItem.id"
                      class="relative mt-px flex h-full"
                      :style="{
                        'grid-column-start': roomIndex + 1,
                        'grid-row':
                          (eventItem.totalTime == 0
                            ? 1
                            : Math.round(eventItem.totalTime / 60 + 1)) +
                          ' / span ' +
                          eventItem.durationInSeconds / 60,
                      }"
                      :class="'col-start-' + (roomIndex + 1) + ' relative'"
                    >
                      <div
                        @click="handleItemClick(eventItem)"
                        :class="[
                          baseItemClasses,
                          getItemDynamicClass(eventItem),
                        ]"
                        :style="{ 'z-index': 20 }"
                      >
                        <div>
                          <!-- Canceled Overlay -->
                          <div
                            class="text-bold text-xs text-red-700 absolute flex justify-center items-center w-full h-full -mt-4"
                            v-if="eventItem.is_canceled"
                          >
                            <div
                              class="rounded-md px-1.5 py-1 font-bold text-base text-red-600 bg-red-100 inline-block shadow-lg mr-5 mb-4"
                            >
                              <i class="fa-solid fa-ban"></i>
                              {{ translate("conference.item_cancelled") }}
                            </div>
                          </div>
                          <!-- Event Name -->
                          <div
                            class="order-1 font-semibold leading-4"
                            :class="
                              'text-custom-' +
                              getSessionColorId(eventItem.event_session_id) +
                              '-900'
                            "
                          >
                            {{ translateField(eventItem.name) }}
                          </div>
                          <!-- Time and Type -->
                          <div class="mb-0.5">
                            <div
                              style="font-size: 0.7rem"
                              class="text-xs inline-block rounded-md px-0.5 py-0"
                              :class="
                                'text-custom-' +
                                getSessionColorId(eventItem.event_session_id) +
                                '-900 bg-custom-' +
                                getSessionColorId(eventItem.event_session_id) +
                                '-200  border-custom-' +
                                getSessionColorId(eventItem.event_session_id) +
                                '-200 text-xs border'
                              "
                            >
                              <time :datetime="getFormattedTime(eventItem)">{{
                                getFormattedTime(eventItem)
                              }}</time>
                              |
                              <span class="font-medium">{{
                                eventItem.event_item_type
                                  ? translateField(
                                      eventItem.event_item_type.name
                                    )
                                  : ""
                              }}</span>
                            </div>
                            <!-- Online Status -->
                            <div
                              :class="
                                'text-custom-' +
                                getSessionColorId(eventItem.event_session_id) +
                                '-600 bg-custom-' +
                                getSessionColorId(eventItem.event_session_id) +
                                '-100'
                              "
                              class="px-1 py-0.5 text-xxs inline-block rounded-md ml-1 font-medium"
                              v-if="
                                (true == true &&
                                  eventItem.is_presented_online) ||
                                (eventData &&
                                  eventData.display_schedule_item_online_status &&
                                  eventItem.is_presented_online)
                              "
                            >
                              <span
                                v-if="
                                  (true == true &&
                                    eventItem.is_presented_online) ||
                                  (eventData &&
                                    eventData.display_schedule_item_online_status &&
                                    eventItem.is_presented_online)
                                "
                                :title="
                                  translate('conference.participation_online')
                                "
                                style="font-size: 0.7rem"
                                ><i class="fa-light fa-globe mr-1"></i>
                                {{
                                  translate("conference.participation_online")
                                }}</span
                              >
                            </div>
                          </div>
                          <!-- Author -->
                          <div
                            class="mt-0.5 text-xs leading-tight text-gray-500 order-2 font-normal author-text"
                            :class="
                              'text-custom-' +
                              getSessionColorId(eventItem.event_session_id) +
                              '-800'
                            "
                          >
                            {{
                              getAuthorText(eventItem)
                                ? getAuthorText(eventItem)["author"]
                                : ""
                            }}
                          </div>
                          <!-- Company -->
                          <div
                            class="text-xxs leading-snug text-gray-500 order-3 font-normal"
                            :class="
                              'text-custom-' +
                              getSessionColorId(eventItem.event_session_id) +
                              '-800'
                            "
                          >
                            {{
                              getAuthorText(eventItem)
                                ? getAuthorText(eventItem)["company"]
                                : ""
                            }}
                          </div>
                        </div>
                      </div>

                      <!-- Session Start Indicator (if exists) - content also remains visible -->
                      <div
                        class="cursor-pointer absolute z-20 bg-white right-0 rounded-md border relative w-4 py-3 shadow-sm overflow-hidden ml-0.5"
                        @click.stop="handleSessionIndicatorClick(eventItem)"
                        v-if="eventItem.session_start"
                        :style="{
                          height:
                            (eventItem.session_duration / 60) * 0.7 + 'rem',
                          zIndex: 30,
                        }"
                        :class="
                          'bg-text-' +
                          getSessionColorId(eventItem.event_session_id) +
                          '-50 bg-custom-' +
                          getSessionColorId(eventItem.event_session_id) +
                          '-800'
                        "
                      >
                        <div>
                          <div
                            class="rotate-90 transform text-gray-400 whitespace-nowrap"
                            style="font-size: 0.67rem"
                            :class="
                              'text-custom-' +
                              getSessionColorId(eventItem.event_session_id) +
                              '-100'
                            "
                          >
                            {{
                              translateField(
                                getSession(eventItem.event_session_id)
                                  .shortRecordName
                              )
                            }}
                          </div>
                        </div>
                      </div>

                      <!-- Animator motion.div (now INSIDE the static li) -->
                      <motion.div
                        v-if="isAnimatorActiveForItem(eventItem)"
                        layout
                        :key="
                          eventItem.id +
                          (selectedEventItem &&
                          selectedEventItem.id === eventItem.id
                            ? '-source'
                            : '-target')
                        "
                        :layoutId="'event-item-' + eventItem.id"
                        class="absolute inset-0 rounded-lg border border-gray-400"
                        :class="getAnimatorShellDynamicClass(eventItem)"
                        :style="{
                          zIndex: 25 /* Ensures animator is on top of static content (z-index: 20) when active */,
                          'pointer-events': 'none',
                          'margin-left': '-2px',
                          'margin-top': '3px',
                        }"
                      >
                        <!-- Empty shell -->
                      </motion.div>
                    </li>
                  </template>
                </template>
              </ol>
            </div>
          </div>
          <div
            class="max-w-screen relative transition transform duration-300 ease-in-out"
            :style="{ transform: 'translateX(' + scrolledFromLeft + 'px)' }"
          >
            <div
              class="text-center my-2 mt-6 text-primary-500 font-light text-sm"
              v-if="
                program && program.exhibitors && program.exhibitors.length > 0
              "
            >
              {{ translate("conference.exhibition") }}
            </div>

            <div
              class="flex justify-center flex-wrap"
              v-if="
                program && program.exhibitors && program.exhibitors.length > 0
              "
            >
              <div
                class="p-4"
                v-for="(exhibitor, index) in program.exhibitors"
                :key="index"
              >
                <a :href="exhibitor.website.A0" target="_blank"
                  ><img
                    class="object-contain max-h-12 max-w-20"
                    :src="exhibitor.logo['oar-md']"
                    alt=""
                    style="max-width: 8rem"
                /></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, nextTick } from "vue";
import _ from "lodash";
import SearchBar from "./SearchBar/SearchBar.vue";
import $ from "jquery";
import { motion, AnimatePresence } from "motion-v";

export default defineComponent({
  name: "ConferenceSchedule",
  components: {
    SearchBar,
    AnimatePresence,
    MotionDiv: motion.div,
    MotionLi: motion.li,
  },
  directives: {
    closable: {
      beforeMount(el, binding, vnode) {
        const { handler: methodName, exclude } = binding.value;
        const ctx = vnode.ctx;
        const onClick = (e) => {
          e.stopPropagation();
          let clickedOnExcluded = false;
          exclude.forEach((refName) => {
            if (!clickedOnExcluded) {
              const excludedEl = ctx.$refs[refName];
              if (excludedEl && excludedEl.contains(e.target)) {
                clickedOnExcluded = true;
              }
            }
          });
          if (!el.contains(e.target) && !clickedOnExcluded) {
            ctx[methodName]();
          }
        };
        document.addEventListener("click", onClick);
        document.addEventListener("touchstart", onClick);
        el.__vueClickOutside__ = onClick;
      },
      unmounted(el) {
        document.removeEventListener("click", el.__vueClickOutside__);
        document.removeEventListener("touchstart", el.__vueClickOutside__);
        delete el.__vueClickOutside__;
      },
    },
  },
  props: {
    autoScroll: {
      type: Boolean,
      default: false,
    },
    addTopMenuClass: String,
    program: Object,
    addMinutes: {
      type: Number,
      default: 1,
    },
    timeLabel: {
      type: Number,
      default: 30,
    },
    entity: {
      type: String,
      default: null,
    },
    runIndependent: {
      type: Boolean,
      default: true,
    },
    eventData: {
      type: Object,
      default: () => null,
    },
    domain: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      customDetailList: null,
      menuHeight: "200px",
      eventRoomsDeselected: [],
      showRoomMenu: false,
      timeRangeLength: [],
      selectedPosterSession: null,
      selectedDate: null,
      selectedEventItem: null,
      selectedEventSession: null,
      scrollerActive: false,
      scrollerMaxL: false,
      scrollerMaxR: false,
      scrolledFromLeft: 0,
      maxSchedule: false,
      timeIndicatorPosition: null,
      currentTime: null,
      closingModalTargetId: null,
      modalAnimationDuration: 400,
      activeModalLayoutId: null, // Added for modal return animation fix
    };
  },
  computed: {
    nextEventItemProperty() {
      return this.nextEventItem(this.selectedEventItem);
    },
    prevEventItemProperty() {
      return this.prevEventItem(this.selectedEventItem);
    },
    styleMainContainer() {
      if (this.maxSchedule) {
        return {
          height: "100vh",
          width: "100vw",
          overflowY: "auto",
          position: "fixed",
          top: "0",
          left: "0",
          zIndex: "1000",
        };
      }
      return {};
    },
    eventItems() {
      return this.$store?.state?.eventItems || [];
    },
    sessionsOfDay() {
      if (
        !this.selectedDate ||
        !this.program?.eventItems?.[this.selectedDate]
      ) {
        return [];
      }
      const sessions = {};
      _.forEach(
        this.program.eventItems[this.selectedDate],
        (roomItems, roomKey) => {
          let temp = _.uniq(_.compact(_.map(roomItems, "event_session_id")));
          let top = _.uniq(temp.map((id) => this.topSessionId(id)));
          sessions[roomKey] = top;
        }
      );
      return sessions;
    },
    eventRoomsMenu() {
      const rooms = this.roomsForDateMenu;
      if (!rooms.length) return [];
      return _.orderBy(
        rooms.map((r) => ({
          id: this.program.rooms[r.event_room_id].id,
          name: this.translateField(this.program.rooms[r.event_room_id].name),
          sorting_name: this.program.rooms[r.event_room_id].sorting_computed,
        })),
        "sorting_name"
      );
    },
    parentEventSession() {
      return this.selectedEventSession
        ? this.getParentSession(this.selectedEventSession)
        : null;
    },
    selectedSessionEventItems() {
      if (!this.selectedEventSession) return [];
      const ids = [
        this.selectedEventSession.id,
        ...this.findSubEventSessionsRecursive(this.selectedEventSession.id),
      ];
      return _.flatten(this.eventItems)
        .filter((item) => ids.includes(item.event_session_id))
        .sort((a, b) => a.timestamp - b.timestamp);
    },
    groupedSessionEventItemsByDate() {
      if (
        !this.selectedSessionEventItems ||
        this.selectedSessionEventItems.length === 0
      ) {
        return [];
      }
      const grouped = _.groupBy(this.selectedSessionEventItems, (item) =>
        window.moment(item.start_time).format("YYYY-MM-DD")
      );

      return _.orderBy(
        Object.keys(grouped).map((dateKey) => {
          const itemsForDate = grouped[dateKey]; // Items are already sorted by timestamp due to selectedSessionEventItems
          return {
            date: dateKey,
            formattedDate: this.getDateObject(
              itemsForDate[0].start_time
            ).format("L (dddd)"),
            items: itemsForDate,
          };
        }),
        ["date"],
        ["asc"]
      );
    },
    posters() {
      if (!this.program?.posters) return [];
      let result = _.sortBy(
        this.program.posters.map((item) => {
          const sess = this.getSession(item.paperpool_event_session_id);
          if (sess) item.paperpool_name = sess.shortRecordName;
          return item;
        }),
        ["paperpool_name", "nameTranslation"]
      ).filter((item) => item.paperpool_name);
      if (this.selectedPosterSession) {
        result = result.filter(
          (item) =>
            item.paperpool_event_session_id === this.selectedPosterSession
        );
      }
      return result;
    },
    posterSessions() {
      if (!this.program?.posters) return {};
      return _.sortBy(
        _.keyBy(
          this.program.posters.map((item) => {
            const sess = this.getSession(item.paperpool_event_session_id);
            return sess
              ? { id: sess.id, paperpool_name: sess.shortRecordName }
              : {};
          }),
          "id"
        ),
        ["paperpool_name"]
      );
    },
    dateMenu() {
      if (!this.program?.dates) return {};
      const res = {};
      for (const key in this.program.dates) {
        const rooms = this.program.dates[key];
        const hasVisible = rooms.some(
          (r) =>
            r.event_room_id != null &&
            !this.program.rooms[r.event_room_id].hidden
        );
        if (hasVisible && this.program.eventItems?.[key]) {
          res[key] = rooms;
        }
      }
      if (this.program?.posters?.length) {
        res.poster = { day: "posters" };
      }
      return res;
    },
    roomColClasses() {
      const classes = this.roomsForDate.map(
        (_, i) => `col-start-${i + 1} row-span-full`
      );
      classes.push(`col-start-${classes.length + 1} row-span-full w-8`);
      return classes;
    },
    roomsForDateMenu() {
      return (this.program?.dates?.[this.selectedDate] || [])
        .filter(
          (x) =>
            x.event_room_id != null &&
            !this.program.rooms[x.event_room_id].hidden
        )
        .sort((a, b) => {
          const nameA = this.translateField(
            this.program.rooms[a.event_room_id].sorting_computed
          );
          const nameB = this.translateField(
            this.program.rooms[b.event_room_id].sorting_computed
          );
          return nameA.localeCompare(nameB);
        });
    },
    roomsForDate() {
      return this.roomsForDateMenu.filter(
        (r) => !this.eventRoomsDeselected.includes(r.event_room_id)
      );
    },
    baseItemClasses() {
      return "cursor-pointer order group absolute inset-1 my-0 pl-5 text-gray-500 border flex bg-white flex-col overflow-y-auto rounded-lg p-1 text-xs leading-tight font-light transform hover:scale-102 duration-300 h-full";
    },
    animatorShellBaseClasses() {
      return "relative mt-px flex rounded-lg";
    },
  },
  methods: {
    handleItemClick(eventItem) {
      if (this.closingModalTargetId) {
        return;
      }
      this.setSelectedEventItem(eventItem);
    },
    handleSessionIndicatorClick(eventItem) {
      if (this.closingModalTargetId) {
        return;
      }
      this.setSelectedEventSession(eventItem.event_session_id);
    },
    isEventItemSelected(eventItem) {
      if (!eventItem) return false;
      return (
        (this.selectedEventItem &&
          this.selectedEventItem.id === eventItem.id) ||
        this.closingModalTargetId === eventItem.id
      );
    },
    isAnimatorActiveForItem(eventItem) {
      if (!eventItem) return false;
      return (
        (this.selectedEventItem &&
          this.selectedEventItem.id === eventItem.id) ||
        this.closingModalTargetId === eventItem.id
      );
    },
    triggerTimeIndicator() {
      this.setTimeIndicatorPosition();
      setTimeout(this.triggerTimeIndicator, 2000);
    },
    setTimeIndicatorPosition() {
      const now = window.moment().tz("Europe/Berlin");
      this.currentTime = now;
      if (!this.selectedDate || !this.program?.event) {
        this.timeIndicatorPosition = null;
        return;
      }
      const [range] = this.program.timeRanges[this.selectedDate] || [];
      const start = window.moment(range.start_time);
      const end = window.moment(range.end_time);
      if (start.isAfter(now) || end.isBefore(now)) {
        this.timeIndicatorPosition = null;
        return;
      }
      const diff = window.moment.duration(now.diff(start)).asMinutes();
      this.timeIndicatorPosition = { minutes: diff, pixel: diff * 0.7 };
      if (this.autoScroll) {
        this.$nextTick(() => {
          const ti = this.$refs.timeIndicator;
          const area = this.$refs.schedule_area;
          if (ti && area) {
            const scrollTop = ti.offsetTop - area.clientHeight / 5;
            area.scrollTo({ top: scrollTop, behavior: "smooth" });
          }
        });
      }
    },
    prevEventItem(item, includeGap = false) {
      if (!item || !item.id) return null;

      let list;
      const isPosterItem = this.posters.find(p => p.id === item.id);

      if (isPosterItem) {
        list = this.posters;
      } else {
        const sourceList =
          this.customDetailList ||
          (this.program.eventItems[item.day] &&
            this.program.eventItems[item.day][item.eventRoomId]);
        if (sourceList) {
          list = sourceList.filter((i) => includeGap || !i.gap);
        } else {
          list = [];
        }
      }

      if (!list || list.length === 0) return null;
      const idx = list.findIndex((i) => i.id === item.id);
      return list[idx - 1] || null;
    },
    nextEventItem(item, includeGap = false) {
      if (!item || !item.id) return null;

      let list;
      const isPosterItem = this.posters.find(p => p.id === item.id);

      if (isPosterItem) {
        list = this.posters;
      } else {
        const sourceList =
          this.customDetailList ||
          (this.program.eventItems[item.day] &&
            this.program.eventItems[item.day][item.eventRoomId]);
        if (sourceList) {
          list = sourceList.filter((i) => includeGap || !i.gap);
        } else {
          list = [];
        }
      }

      if (!list || list.length === 0) return null;
      const idx = list.findIndex((i) => i.id === item.id);
      return list[idx + 1] || null;
    },
    closeRoomDropdown() {
      this.showRoomMenu = false;
    },
    styleRoomMenu() {
      if (this.$refs.roomMenu && this.$refs.dateMenu) {
        return { top: this.$refs.dateMenu.clientHeight - 3 + "px" };
      }
      return {};
    },
    setBodyTag() {
      document.body.style.overflow = this.maxSchedule ? "hidden" : "";
    },
    topSessionId(id) {
      const s = this.program.sessions[id];
      return s?.parent_event_session_id
        ? this.topSessionId(s.parent_event_session_id)
        : id;
    },
    findSubEventSessionsRecursive(id) {
      const subs = _.filter(
        this.program.sessions,
        (s) => s.parent_event_session_id === id
      ).map((s) => s.id);
      return subs.reduce(
        (all, sid) => all.concat(sid, this.findSubEventSessionsRecursive(sid)),
        []
      );
    },
    onlyRoom(id) {
      this.eventRoomsDeselected = Object.values(this.program.rooms)
        .filter((r) => r.id !== id)
        .map((r) => r.id);
    },
    addOrRemoveRoom(id) {
      const idx = this.eventRoomsDeselected.indexOf(id);
      if (idx > -1) this.eventRoomsDeselected.splice(idx, 1);
      else this.eventRoomsDeselected.push(id);
    },
    checkWidth() {
      if (this.showRoomMenu && this.$refs.roommenu && this.$refs.roomDropdown) {
        let menuContainer = this.$refs.roomDropdown.clientHeight;
        let maxMenuHeight =
          window.innerHeight - this.$refs.roommenu.offsetTop - 80;
        console.log(
          "menuHeight",
          maxMenuHeight,
          "menuContainer",
          menuContainer
        );
        if (maxMenuHeight < menuContainer) {
          this.menuHeight = maxMenuHeight + "px";
        } else {
          this.menuHeight = menuContainer + "px";
        }
      } else {
        this.menuHeight = 200 + "px";
      }

      var maxScrollLeft =
        $(".schedule-widget-area").get(0).scrollWidth -
        $(".schedule-widget-area").get(0).clientWidth;
      var left = $(".schedule-widget-area").scrollLeft();
      this.scrolledFromLeft = left;
      maxScrollLeft = maxScrollLeft - 15;
      var total = left - 15;
      if (total < 0) {
        total = 0;
      }
      if (total == 0) {
        this.scrollerMaxL = true;
      } else {
        this.scrollerMaxL = false;
      }

      if (total >= maxScrollLeft) {
        total = maxScrollLeft;
        this.scrollerMaxR = true;
      } else {
        this.scrollerMaxR = false;
      }
      setTimeout(this.checkWidth, 30);
    },
    moveSchedule(amount) {
      this.scrollerActive = true;
      var maxScrollLeft =
        $(".schedule-widget-area").get(0).scrollWidth -
        $(".schedule-widget-area").get(0).clientWidth;
      var left = $(".schedule-widget-area").scrollLeft();

      var total = left + amount;
      if (total < 0) {
        total = 0;
      }
      if (total == 0) {
        this.scrollerMaxL = true;
      } else {
        this.scrollerMaxL = false;
      }

      if (total >= maxScrollLeft) {
        total = maxScrollLeft;
        this.scrollerMaxR = true;
      } else {
        this.scrollerMaxR = false;
      }

      $(".schedule-widget-area").animate({ scrollLeft: total }, 150);
      this.scrollerActive = false;
      setTimeout(() => {
        if (this.scrollerActive) {
          // this.moveSchedule(amount)
        }
      }, 350);
    },
    loopSelectedDate() {
      setTimeout(() => {
        if (!this.selectedDate && Object.keys(this.dateMenu).length) {
          const today = window.moment().format("YYYY-MM-DD");
          this.selectedDate = this.dateMenu[today]
            ? today
            : Object.keys(this.dateMenu)[0];
        }
        this.loopSelectedDate();
      }, 500);
    },
    getParentSession(sess) {
      const id = sess.id || sess;
      const parent = this.program.sessions[id]?.parent_event_session_id;
      return parent ? this.program.sessions[parent] : null;
    },
    getPosterImage(p) {
      if (p.exhibitor) return { sm: p.logo["oar-thumb"] };
      if (!p.posterImage)
        return {
          sm: "https://dgm.inventum.de/storage/defaultImages/poster.jpg",
        };
      return p.posterImage.md
        ? p.posterImage
        : { sm: p.posterImage["oar-thumb"] };
    },
    loadJs(url, cb) {
      const s = document.createElement("script");
      s.src = url;
      s.type = "text/javascript";
      s.onload = () => cb?.();
      document.head.appendChild(s);
    },
    setSelectedEventItem(orig, isPoster=false) {

      if(orig == null) {
        this.selectedEventItem = null;
        return;
      }
      let item = orig;
      if (orig && typeof orig !== "object") {
        item =
          this.eventItems.flat().find((x) => x && x.id === orig) ||
          this.posters.find((x) => x && x.id === orig);
      }
      if (!item || !item.id) return;

      

      
      if(isPoster){
        this.selectedDate = "poster";
      }else{
        this.selectedDate = item.day || "poster";
      }

      console.log("selectedDate",this.selectedDate,"isPoster",isPoster);
      this.selectedEventItem = item;
      this.selectedEventSession = null;
      this.closingModalTargetId = null;
      this.activeModalLayoutId = "event-item-" + item.id; // Ensure this is always set for the opening animation
      if(isPoster){
        return;
      }
      
      nextTick(() => {
        const refValue = this.$refs[`schedule-item-${item.id}`];
        const element = Array.isArray(refValue) ? refValue[0] : refValue;

        if (this.selectedDate !="posters" && element && typeof element.scrollIntoView === "function") {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
          console.warn(
            "ConferenceSchedule: Could not scroll to item. Element or scrollIntoView not found.",
            { itemId: item.id, refValue, element }
          );
        }
        setTimeout(() => MathJax.Hub.Queue(["Typeset", MathJax.Hub]), 300);
      });
    },
    setSelectedEventSession(sess_id) {
      // Changed to accept sess_id
      if(sess_id == null) {
        this.selectedEventSession = null;
        return;
      }
      this.selectedEventItem = null;
      const s = this.getSession(sess_id); // Directly use getSession with ID
      this.selectedEventSession = s;
      console.log("selectedEventSession",sess_id, s);
      // No need to set activeModalLayoutId here as this is for session modal, not event item modal
      setTimeout(() => MathJax.Hub.Queue(["Typeset", MathJax.Hub]), 300);
    },
    unsetSelectedEventSession() {
      this.selectedEventSession = null;
    },
    unsetSelectedEventItem() {
      if (this.selectedEventItem) {
        // activeModalLayoutId on the modal panel is already correct from the last setSelectedEventItem call.
        this.closingModalTargetId = this.selectedEventItem.id; // This makes the target list item's shell appear.

        // Setting selectedEventItem to null will trigger AnimatePresence for the modal root.
        // The modal panel inside, with its current activeModalLayoutId, should animate to the
        // list item shell that now shares the same layoutId (due to closingModalTargetId).
        this.selectedEventItem = null;

        setTimeout(() => {
          this.closingModalTargetId = null;
          this.activeModalLayoutId = null; // Clear after animation
        }, this.modalAnimationDuration);
      } else {
        this.closingModalTargetId = null;
        this.activeModalLayoutId = null;
      }
    },
    unsetAll() {
      let itemClosed = false;
      if (this.selectedEventItem) {
        // activeModalLayoutId on the modal panel is already correct.
        this.closingModalTargetId = this.selectedEventItem.id;
        itemClosed = true;
      } else {
        this.closingModalTargetId = null;
        if (!this.selectedEventSession) {
          this.activeModalLayoutId = null;
        }
      }

      this.selectedEventItem = null;
      this.selectedEventSession = null;

      if (itemClosed) {
        setTimeout(() => {
          this.closingModalTargetId = null;
          this.activeModalLayoutId = null; // Clear after animation
        }, this.modalAnimationDuration);
      } else if (!this.selectedEventSession) {
        this.activeModalLayoutId = null;
      }
    },
    getDateObject(s) {
      return window.moment(s, "YYYY-MM-DD");
    },
    getAuthorText(i) {
      return i.authorText?.A0 ?? this.translateField(i.authorText);
    },
    getFormattedTime(i) {
      return window.moment(i.start_time || i).format("LT");
    },
    getSessionColorId(id) {
      return this.program.sessions[id]?.color_id || "0";
    },
    getSession(id) {
      
      return this.program.sessions[id] || null;
    },
    isFavorit() {
      return false;
    },
    setTimerangeLength() {
      if (!this.selectedDate || !this.program?.timeRanges?.[this.selectedDate])
        return;
      let start = window.moment(
        this.program.timeRanges[this.selectedDate][0].start_time
      );
      const end = window.moment(
        this.program.timeRanges[this.selectedDate][0].end_time
      );
      const span = [];
      while (start.isBefore(end)) {
        span.push({
          hour: start.format("H"),
          minute: start.format("mm"),
          format: start.format("LT"),
        });
        start.add(this.addMinutes, "m");
      }
      this.timeRangeLength = span;
    },
    getItemDynamicClass(eventItem) {
      let classes = " ";
      if (eventItem.is_canceled) {
        classes += "bg-gray-50 border-gray-100 opacity-50";
      } else {
        classes +=
          "bg-custom-" +
          this.getSessionColorId(eventItem.event_session_id) +
          "-50 border-custom-" +
          this.getSessionColorId(eventItem.event_session_id) +
          "-100 hover:bg-custom-" +
          this.getSessionColorId(eventItem.event_session_id) +
          "-100";
      }
      return classes;
    },
    getAnimatorShellDynamicClass(eventItem) {
      // roomIndex is no longer needed here as col-start is not set on the shell directly
      let classes = " "; // Base classes for the shell, e.g., rounded corners if not covered by bg
      if (eventItem.is_canceled) {
        classes += "border-gray-400 border opacity-50 z-30";
      } else {
        classes +=
          "border border-custom-" +
          this.getSessionColorId(eventItem.event_session_id) +
          "-400";
      }
    },
  },
  created() {
    this.loadJs(
      "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-MML-AM_CHTML"
    );
  },
  mounted() {
    nextTick(() => this.setTimerangeLength());
    this.triggerTimeIndicator();
    setTimeout(() => {
      this.maxSchedule = true;
    }, 1000);
    this.loopSelectedDate();
    this.setBodyTag();
    this.checkWidth();
    nextTick(() =>
      setTimeout(() => MathJax.Hub.Queue(["Typeset", MathJax.Hub]), 2000)
    );
    document.onkeydown = (e) => {
      if (
        e.key === "ArrowRight" &&
        this.selectedEventItem &&
        this.nextEventItemProperty
      ) {
        this.setSelectedEventItem(this.nextEventItemProperty);
      }
      if (
        e.key === "ArrowLeft" &&
        this.selectedEventItem &&
        this.prevEventItemProperty
      ) {
        this.setSelectedEventItem(this.prevEventItemProperty);
      }
      if (e.key === "Escape") this.unsetAll();
    };
  },
  watch: {
    program() {
      nextTick(() => this.setTimerangeLength());
    },
    selectedDate() {
      nextTick(() => {
        this.setTimerangeLength();
        nextTick(() =>
          setTimeout(() => MathJax.Hub.Queue(["Typeset", MathJax.Hub]), 2000)
        );
      });
    },
  },
});
</script>

<style>
.author-text {
  font-size: 0.7rem;
}

.col-start-14 {
  grid-column-start: 14;
}

.col-start-15 {
  grid-column-start: 15;
}

.col-start-16 {
  grid-column-start: 16;
}

.col-start-17 {
  grid-column-start: 17;
}

.col-start-18 {
  grid-column-start: 18;
}

.col-start-19 {
  grid-column-start: 19;
}

.col-start-20 {
  grid-column-start: 20;
}

.col-start-21 {
  grid-column-start: 21;
}

.col-start-22 {
  grid-column-start: 22;
}

.col-start-23 {
  grid-column-start: 23;
}

.col-start-24 {
  grid-column-start: 24;
}

.col-start-25 {
  grid-column-start: 25;
}

.col-start-26 {
  grid-column-start: 26;
}

.col-start-27 {
  grid-column-start: 27;
}

.col-start-28 {
  grid-column-start: 28;
}

.col-start-29 {
  grid-column-start: 29;
}

.col-start-30 {
  grid-column-start: 30;
}

.col-start-31 {
  grid-column-start: 31;
}

.col-start-32 {
  grid-column-start: 32;
}

.col-start-33 {
  grid-column-start: 33;
}

.col-start-34 {
  grid-column-start: 34;
}

.col-start-35 {
  grid-column-start: 35;
}

.col-start-36 {
  grid-column-start: 36;
}

.col-start-37 {
  grid-column-start: 37;
}

.col-start-38 {
  grid-column-start: 38;
}

.col-start-39 {
  grid-column-start: 39;
}

.col-start-40 {
  grid-column-start: 40;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 300ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

@media print {
  /* All your print styles go here */
  .sticky {
    display: block !important;
  }

  .overflow-auto {
    overflow: visible !important;
  }
}
</style>
